// removed by extract-text-webpack-plugin
module.exports = {"theme":"#DDAC69"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/element-variables.scss
// module id = +hAf
// module chunks = 80